import { connect } from 'react-redux';
import { addJournalEntryBegin } from '../../../../store/actions/accounting.actions';
import { getAccountingUpdateStatus } from '../../../../store/selectors/accounting.selectors';
import {
    getPersonAccounting,
    getPersonAccountingErrorStatus,
    getPersonAccountingStatus,
} from '../../../../store/selectors/person.selectors';
import Accounting from '../../../CommonTabs/Accounting';

const mapStateToProps = (state: any) => ({
    transactionList: getPersonAccounting(state),
    loading: getPersonAccountingStatus(state),
    updateStatus: getAccountingUpdateStatus(state),
    errorStatus: getPersonAccountingErrorStatus(state),
});

const mapDispatchToProps = {
    addJournalEntry: addJournalEntryBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(Accounting);
